import AreasTurnos from '../components/AreasTurnos/Matriz.vue'

let routes = {
    path: '/events',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/areasTurnos',
            name: 'areasTurnos',
            component: AreasTurnos
        }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/areasturnos.js